// One teams-managerteams round trip, shared by the teams screens.
//
// Every screen loads it fresh rather than caching: a tie stores no times and no courts, and the
// rubbers' when-and-where is joined from the reservations server-side on each call. Caching it
// would show the manager yesterday's booking with nothing to reveal the drift (spec invariant 4).
//
// The call also maintains the caller's acl.teammanager flag server-side, so it is not a pure
// read - fire it on mount and on explicit reload, never in a loop or a render.
import { useEffect, useState } from 'react'
import { useTeamsApi } from './teamsapi'

export function useManagerTeams({ appconfig }) {
  const api = useTeamsApi({ appconfig })
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [failure, setFailure] = useState(null)
  const [reloads, setReloads] = useState(0)
  const accountkey = appconfig && appconfig.accountkey

  useEffect(() => {
    if (!accountkey) return undefined
    let alive = true
    setLoading(true)
    api.managerTeams().then((res) => {
      if (!alive) return
      if (res.ok) {
        setData(res.data)
        setFailure(null)
      } else {
        setFailure(res)
      }
      setLoading(false)
    })
    return () => {
      alive = false
    }
    // api is rebuilt every render; the account and an explicit reload are what should refetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountkey, reloads])

  return { loading, data, failure, reload: () => setReloads((n) => n + 1) }
}
